import { type z } from "zod"
import { type ProductTagSchema } from "../schemas/productTag"

export type ProductTag = z.infer<typeof ProductTagSchema>

export const ProductTag = {
    CHANGE_OF_SUPPLIER: "change_of_supplier",
    COCON: "cocon",
    COCON_FALLBACK: "cocon_fallback",
    COMMISSIONING: "commissioning",
    DRIVE_PACK_29: "drive_pack_29",
    DRIVE_PACK_44: "drive_pack_44",
    DRIVE_PACK_49: "drive_pack_49",
    EFFY_CONFORT_LARGE: "effy_confort_large",
    EFFY_CONFORT_MEDIUM: "effy_confort_medium",
    EFFY_CONFORT_SMALL: "effy_confort_small",
    EFFY_PILOTAGE_PAC: "effy_pilotage_pac",
    ELECTRIC_VEHICLE: "electric_vehicle",
    FLEX_OFFER: "flex_offer",
    LINKY_LEVEL_2: "linky_level_2",
} as const satisfies Record<Uppercase<ProductTag>, ProductTag>
